import { AppState } from 'src';
import { AccountingListComponentProperties, AccountingListComponent } from './accounting-list.component';
import { Dispatch, connect } from 'react-redux';
import { ModalProps } from '@common/components';
import { toggleModal } from '@common/components/common.actions';
import { searchCancelledContractsList, changeAccountingOwnership } from 'src/accounting/accounting.actions';

function mapStateToProps(state: AppState, ownProps: {}): Partial<AccountingListComponentProperties> {
  return {
    user: state.auth.currentProfile,
    message: state.accounting.message,
    query: state.accounting.query,
    loading: state.accounting.loading,
    pageCount: state.accounting.pageCount,
    pageNumber: state.accounting.pageNumber,
    pageSize: state.accounting.pageSize,
    filterByDisbursed: state.accounting.filterByDisbursed,
    cancelledContractsList: state.accounting.cancelledContractsList
  };
}

function mapDispatchToProps(dispatch: Dispatch<AppState>, ownProps: {}): Partial<AccountingListComponentProperties> {
  return {
    searchCancelledContractsList(
      query: string | null,
      pageSize: number,
      pageNumber: number,
      orderBy: string,
      orderDirection: string,
      filterByDisbursed: boolean
    ) {
      dispatch(searchCancelledContractsList(query, pageSize, pageNumber, orderBy, orderDirection, filterByDisbursed));
    },
    toggleModal: (modalProps: ModalProps) => {
      dispatch(toggleModal(modalProps));
    },
    handleOwnershipChange(
      contractId: number,
      query: string | null,
      pageSize: number,
      pageNumber: number,
      orderBy: string,
      orderDirection: string,
      filterByDisbursed: boolean,
      release?: boolean
    ) {
      dispatch(changeAccountingOwnership(contractId, release))
        .then(() => {
          setTimeout(
            () =>
              dispatch(
                searchCancelledContractsList(query, pageSize, pageNumber, orderBy, orderDirection, filterByDisbursed)
              ),
            1000
          );
        })
        .catch(e => console.error(e.toString()));

      dispatch(toggleModal());
    }
  };
}

export const AccountingList = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountingListComponent);



// WEBPACK FOOTER //
// ./src/accounting/_components/accounting-list/accounting-list.container.tsx